'use strict';

wbApp.controller('StateCodesCtrl', ['$scope', '$modal', 'stateCodesSvc',
function ($scope, $modal, stateCodesSvc) {
    
    $scope.stateCodes = stateCodesSvc.getAllAsync();

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['name'], directions: ['dsc'] },
        columnDefs: [{ field: 'name', displayName: "TXT_LBL_NAME", width: '140px' },
                          { field: 'description', displayName: "TXT_LBL_DESCRIPTION" }]
    };

    $scope.stateCodeDetail = { name: "", description: "" };
    $scope.stateCodeDetailOrig;

    $scope.onRowEdit = function (data) {
        $scope.stateCodeDetail.id = data.id;
        $scope.stateCodeDetail.name = data.name;
        $scope.stateCodeDetail.description = data.description;

        $scope.stateCodeDetailOrig = angular.copy($scope.stateCodeDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.detailError = null;

    $scope.onRowAdd = function () {
        $scope.stateCodeDetail.id = -1;
        $scope.stateCodeDetail.name = "";
        $scope.stateCodeDetail.description = "";

        $scope.stateCodeDetailOrig = angular.copy($scope.stateCodeDetail);

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        stateCodesSvc.remove(data);
    }

    $scope.onStateCodeDetailSave = function (data) {
        stateCodesSvc.save(data, function (successResult) {
            detailDialogPromise.hide();
        }, function (errorResult) {
            $scope.detailError = errorResult;
        });
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.stateCodeDetailOrig);
    };

    var detailDialogPromise = $modal({
        templateUrl: 'preview-hours/state-codes-detail.html',
        show: false,
        scope: $scope
    });
}]);